import { course, option } from '../bootstrap';

const yearValues = () => {
  const dt = new Date();
  let years = [];

  for (let i = dt.getFullYear(); i > 1949; i--) {
    years.push({ label: i, value: i });
  }

  return years;
};

export const citizenshipOptions = [
  { label: 'Singapore Citizen', value: 'Singapore Citizen' },
  { label: 'Singapore PR', value: 'Singapore PR' },
  {
    label: 'Non-Singapore Citizen/PR',
    value: 'Non-Singapore Citizen/PR',
  },
];

export const salutationOptions = [
  { label: 'Dr', value: 'Dr' },
  { label: 'Mr', value: 'Mr' },
  { label: 'Mdm', value: 'Mdm' },
  { label: 'Ms', value: 'Ms' },
  { label: 'Miss', value: 'Miss' },
];

export const nricColourOptions = [
  { label: 'Pink', value: 'Pink' },
  { label: 'Blue', value: 'Blue' },
];

export const genderOptions = [
  { label: 'Male', value: 'Male' },
  { label: 'Female', value: 'Female' },
];

export const raceOptions = [
  { label: 'Chinese', value: 'Chinese' },
  { label: 'Indian', value: 'Indian' },
  { label: 'Malay', value: 'Malay' },
  { label: 'Others', value: 'Others' },
];

export const employmentOptions = [
  { label: 'Employed', value: 1 },
  { label: 'Self-Employed', value: 2 },
  { label: 'Unemployed', value: 0 },
];

export const sponsorshipOptions = [
  { label: 'Self-sponsored', value: 0 },
  { label: 'Company-sponsored', value: 1 },
];

export const paymentOptions = [
  {
    label: 'Visa / MasterCard Personal Card',
    value: 'Visa / MasterCard Personal Card',
  },
  {
    label: 'Visa / MasterCard Corporate Card',
    value: 'Visa / MasterCard Corporate Card',
  },
];

export const hearAboutOptions = [
  { label: 'AlumNUS Magazine', value: 'AlumNUS Magazine' },
  { label: 'Business Times', value: 'Business Times' },
  { label: 'Colleagues/Friends', value: 'Colleagues/Friends' },
  { label: 'Company HR', value: 'Company HR' },
  { label: 'Facebook', value: 'Facebook' },
  { label: 'Financial Times', value: 'Financial Times' },
  { label: 'Google Ad', value: 'Google Ad' },
  { label: 'Google Search', value: 'Google Search' },
  { label: 'HR Summit', value: 'HR Summit' },
  { label: 'HRM Magazine', value: 'HRM Magazine' },
  { label: 'LinkedIn', value: 'LinkedIn' },
  { label: 'NUS Email', value: 'NUS Email' },
  {
    label: 'NUS Business School Webpage',
    value: 'NUS Business School Webpage',
  },
  { label: 'The Straits Times', value: 'The Straits Times' },
  { label: 'Today', value: 'Today' },
  { label: 'Yahoo Ad', value: 'Yahoo Ad' },
  { label: 'Yahoo Search', value: 'Yahoo Search' },
  { label: 'Skillsfuture website', value: 'Skillsfuture website' },
  { label: 'Others', value: 'Others' },
];

export const yearOptions = [...yearValues()];

export const initValues = {
  alumni: false,
  citizenship: 'Singapore Citizen',
  company_name: '',
  contact_no: '',
  course_id: course,
  date_of_birth: null,
  email: '',
  emergency_contact_name: '',
  emergency_contact_no: '',
  gender: '',
  hear_about: '',
  home_address: '',
  job_title: '',
  mailing_list: false,
  name: '',
  nric: '',
  nric_colour: '',
  payment_method: '',
  pdpa: false,
  programme: '',
  programme_year: '',
  race: '',
  salutation: '',
  skillsfuture_credit: false,
  sme: false,
  sponsorship: 0,
  tag_preferred_name: '',
  ssg_grant: false,
  wts_eligibility: false,
  option: option,
  billing_contact_salutation: '',
  billing_contact_first_name: '',
  billing_contact_last_name: '',
  billing_contact_company: '',
  billing_contact_job_title: '',
  billing_contact_email: '',
  billing_contact_no: '',
  billing_address: '',
};

export const appNavLeft = [
  { title: 'Home', url: 'https://business.nus.edu.sg/' },
  {
    title: 'Biz Short Courses',
    url: 'https://business.nus.edu.sg/#skipcategories',
  },
  {
    title: 'Summer Programme',
    url:
      'https://bschool.nus.edu.sg/L3/courses/finance-big-data-and-analytics-summer-programme',
  },
];

export const appNavRight = [
  {
    title: 'Course Funding Information',
    url: 'https://business.nus.edu.sg/mod/page/view.php?id=4',
  },
];

export const quickLinks = [
  {
    title: 'Undergraduate',
    url: 'https://bschool.nus.edu.sg/prospective-students/undergraduate',
  },
  {
    title: 'Graduate',
    url: 'https://bschool.nus.edu.sg/prospective-students/graduate',
  },
  {
    title: 'Executive Education',
    url: 'http://executive-education.nus.edu/',
  },
];

export const appSettings = {
  title: 'Biz Short Courses',
};
